<!-- src/app/home/home.component.html -->

<section class="hero">
    <div class="hero-content">
      <h1>Transend Financial</h1>
      <p>Fintech Company | B2B</p>
      <a routerLink="/apply" class="btn btn-primary">Apply Now</a>
    </div>
  </section>
  
  <section class="about">
    <div class="container">
      <h2>About Us</h2>
      <p>
        At Transend Financial, we specialize in providing cutting-edge financial solutions tailored for businesses. Our mission is to empower companies with innovative fintech tools that drive growth and efficiency.
      </p>
    </div>
  </section>
  
  <section class="services">
    <div class="container">
      <h2>Our Services</h2>
      <div class="service-cards">
        <div class="card">
          <i class="icon fas fa-chart-line"></i>
          <h3>Financial Analytics</h3>
          <p>Leverage data-driven insights to make informed financial decisions.</p>
        </div>
        <div class="card">
          <i class="icon fas fa-lock"></i>
          <h3>Secure Transactions</h3>
          <p>Ensure all your financial transactions are safe and secure.</p>
        </div>
        <div class="card">
          <i class="icon fas fa-cogs"></i>
          <h3>Custom Solutions</h3>
          <p>Tailored fintech solutions to meet your unique business needs.</p>
        </div>
      </div>
    </div>
  </section>
  
  <section class="cta">
    <div class="container">
      <h2>Ready to Transform Your Financial Operations?</h2>
      <a routerLink="/apply" class="btn btn-secondary">Get Started</a>
    </div>
  </section>
  